export const setCookieData = (data) => ({
  type: 'SET_COOKIE_DATA',
  data,
});
